import { Auth0Provider as Auth0ProviderBase } from '@auth0/auth0-react'
import type { AppState } from '@auth0/auth0-react'
import type { ReactNode } from 'react'
import { AppAuthProvider } from './AppAuthContext'

const domain = import.meta.env.VITE_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
const audience = import.meta.env.VITE_AUTH0_AUDIENCE

interface Auth0ProviderProps {
  children: ReactNode
}

export function Auth0Provider({ children }: Auth0ProviderProps) {
  if (!domain || !clientId) {
    console.error('Auth0 configuration missing. Please set VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID')
    return <>{children}</>
  }

  // Handle the redirect callback - clean up URL and navigate
  const onRedirectCallback = (appState?: AppState) => {
    // Replace the URL to remove the ?code= and ?state= parameters, and return to
    // the route that initiated login (e.g. /invite/:token).
    const targetUrl = appState?.returnTo || window.location.pathname
    window.history.replaceState({}, document.title, targetUrl)

    // React Router doesn't observe history.replaceState(), so we manually notify.
    window.dispatchEvent(new PopStateEvent('popstate'))
  }

  return (
    <Auth0ProviderBase
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: 'openid profile email offline_access',
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="localstorage"
    >
      <AppAuthProvider>
        {children}
      </AppAuthProvider>
    </Auth0ProviderBase>
  )
}
